<div class="w-12"
     [ngClass]="component.ratio || ''"
     [ngStyle]="{'background-color': component.bg_color || '#FFFFFF'}">
    <div class="fill flex flex-middle flex-justify-center">
        <div class="p-l p-r"
             [ngClass]="component.text_align || ''"
             style="max-width: 550px;">
            <h6 class="h2"
                *iCms="'title' of component"></h6>

            <p class="p1 m-t-1"
               *iCms="'topCopy' of component"></p>

            <newsletter-form class="m-t w-12"
                             [hidePrivacyPolicy]="true"
                             source="subscription_module"
                             [ctaCopy]="component?.cta_copy" />

            <p class="c1 m-t-2"
               *iCms="'bottomCopy' of component; content: 'html'"></p>
        </div>
    </div>
</div>